import type React from 'react';
import type { Id } from '../timeline/react-calendar-timeline';
import { createZustandContext } from './ZustandContext';

export type VoyageMenuContextValue = {
  setContextItemId?: (itemId: Id) => void;
  getItemMenuButtonProps?: (
    extra: React.HTMLAttributes<Element>,
  ) => React.HTMLAttributes<Element>;
};

export const VoyageMenuContext = createZustandContext<VoyageMenuContextValue>();
